import exploreEditorUrl from 'url:../../assets/images/explore-editor.svg';
import addNewContentUrl from 'url:../../assets/images/add-new-content.svg';
import makeItVisualUrl from 'url:../../assets/images/make-it-visual.svg';

export interface Tip {
  img: string;
  description: string;
  header: string;
  key: number;
}

export const tips: Tip[] = [
  {
    key: 0,
    header: 'Explore the editor',
    description:
      'Confluence is your playground.  To get a fresh start, just reload the page.',
    img: exploreEditorUrl
  },
  {
    key: 1,
    header: 'Add new content',
    description:
      'Type / on the document to add emojis, actions items, and links',
    img: addNewContentUrl
  },
  {
    key: 2,
    header: 'Make it visual',
    description: 'Use dynamic layouts and tables to organize your ideas',
    img: makeItVisualUrl
  }
];
